// src/router.js
import VueRouter from 'vue-router'
import Vue from 'vue'

import Home from './components/Home'
import Profile from './components/Profile'
import Auth from './components/auth/Auth'
import Cmdblist from './components/cmdb/Cmdblist'
import Ipmanlist from './components/ipman/Ipmanlist'
import Ipmanbrowse from './components/ipman/Ipmanbrowse'
import Ipmansearch from './components/ipman/Ipmansearch'


const routes = [
  { path: '/', component: Home, meta: { requiresAuth: true} },
  { path: '/home', component: Home, meta: { requiresAuth: true} },
  { path: '/auth', component: Auth },
  { path: '/profile', component: Profile, meta: { requiresAuth: true} },
  { path: '/cmdb', component: Cmdblist, meta: { requiresAuth: true} },
  { path: '/ipman', component: Ipmanlist, meta: { requiresAuth: true} },
  { name:'browse', path: '/ipman/browse', component: Ipmanbrowse, props: true, meta: { requiresAuth: true} },
  { path: '/ipman/search', component: Ipmansearch, meta: { requiresAuth: true} }

]

const router = new VueRouter({
  mode: 'history',
  routes
})


router.beforeEach((to, from, next) => {

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // let user;
    Vue.prototype.$Amplify.Auth.currentAuthenticatedUser({
      bypassCache: true 
    }).then(data => {
      if (data && data.signInUserSession) {
        let user = data
        // console.log(data.signInUserSession.accessToken.payload['cognito:groups'])       
        next()
      } 
      else {
        next({
          path: '/auth'
        }) 
      }
     }).catch((e) => {
        next({
          path: '/auth'
        })
    })
  } else next()
})

export default router